import styled from "styled-components";

export const StyledErrorMessage = styled.div`
  border-left: 2px solid #e4251b;
  background-color: #fff2f1;
  margin: 0 28px;
  padding: 8px;
`;
